import React from 'react'
import './LoanCard.css'

const LoanCard = ({ applicant, amount, repaymentPeriod, applicationDate, status }) => {
  return (
    <div className='loan-profile-container'>
        <div className='loan-details'>
            <h3>KES: {amount}</h3>
            <div className='loan-info'>
              <p>Repayment Period: {repaymentPeriod}</p>
              <p>Application Date: {applicationDate}</p>
            </div>
        </div>
        <div className='loan-status'>
          {status}
        </div>
    </div>
  )
}

export default LoanCard